import React from "react";

const Flex = (props) => {
  return (
    <div className="flex h-100" style={props.style}>
      {props.children}
    </div>
  );
};

export default Flex;
